import React from "react";
import "./cardDepo.css";

export default function App({ Nome, SubNome, Texto, LinkImageDepo, White }) {
	return (
		<div className="cDepoCard" style={{ width: "100%", height: "100%" }}>
			<div className="border-vertical"></div>
			<div className="cDepoPerson">
				<img src={LinkImageDepo} width="30%" />
				<div className="cDepoText">
					<h5 className="cDepoTitle">{Nome}</h5>
					<p>{SubNome}</p>
				</div>
			</div>
			<div
				className={`${
					White ? "cDepoBodyTextWhite" : "cDepoBodyText"
				} text-center`}
			>
				<div>"{Texto}"</div>
			</div>
		</div>
	);
}
